module.exports = __webpack_public_path__ + "static/media/notificacao.3a60f09f.wav";